import { render, staticRenderFns } from "./Diagram.vue?vue&type=template&id=427b5252&scoped=true&"
import script from "./Diagram.vue?vue&type=script&lang=js&"
export * from "./Diagram.vue?vue&type=script&lang=js&"
import style0 from "./Diagram.vue?vue&type=style&index=0&id=427b5252&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "427b5252",
  null
  
)

export default component.exports